var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70711 9.95956C2.31658 10.3501 2.31658 10.9832 2.70711 11.3738L4.62623 13.2929C5.01675 13.6834 5.64992 13.6834 6.04044 13.2929L13.2929 6.04044C13.6834 5.64992 13.6834 5.01675 13.2929 4.62623L11.3738 2.70711C10.9832 2.31658 10.3501 2.31658 9.95956 2.70711L2.70711 9.95956Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M4.14645 10.8536C4.34171 11.0488 4.65829 11.0488 4.85355 10.8536C5.04882 10.6583 5.04882 10.3417 4.85355 10.1464L4.14645 10.8536ZM3.14645 9.85355L4.14645 10.8536L4.85355 10.1464L3.85355 9.14645L3.14645 9.85355Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M6.64645 10.3536C6.84171 10.5488 7.15829 10.5488 7.35355 10.3536C7.54882 10.1583 7.54882 9.84171 7.35355 9.64645L6.64645 10.3536ZM4.64645 8.35355L6.64645 10.3536L7.35355 9.64645L5.35355 7.64645L4.64645 8.35355Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M7.64645 8.35355C7.84171 8.54882 8.15829 8.54882 8.35355 8.35355C8.54882 8.15829 8.54882 7.84171 8.35355 7.64645L7.64645 8.35355ZM5.64645 6.35355L7.64645 8.35355L8.35355 7.64645L6.35355 5.64645L5.64645 6.35355Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M9.64645 7.35355C9.84171 7.54882 10.1583 7.54882 10.3536 7.35355C10.5488 7.15829 10.5488 6.84171 10.3536 6.64645L9.64645 7.35355ZM7.64645 5.35355L9.64645 7.35355L10.3536 6.64645L8.35355 4.64645L7.64645 5.35355Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M10.1464 4.85355C10.3417 5.04882 10.6583 5.04882 10.8536 4.85355C11.0488 4.65829 11.0488 4.34171 10.8536 4.14645L10.1464 4.85355ZM9.14645 3.85355L10.1464 4.85355L10.8536 4.14645L9.85355 3.14645L9.14645 3.85355Z",
    fill: "currentcolor"
  })));
}
export default SvgRuler;